// After a deploy an open tab still holds the old index.html, so lazy chunks it asks for no longer exist.
// One reload picks up the fresh build; the flag prevents a reload loop if the chunk is really missing.
const RELOAD_FLAG = 'stale_build_reloaded';

export const isChunkLoadError = (error) => (
  error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk .* failed/i.test(error?.message || '')
);

export const reloadIfStaleBuild = (error) => {
  if (!isChunkLoadError(error)) return false;

  try {
    if (sessionStorage.getItem(RELOAD_FLAG)) return false;
    sessionStorage.setItem(RELOAD_FLAG, '1');
  } catch (e) {
    return false;
  }

  window.location.reload();
  return true;
};

export const clearStaleBuildFlag = () => {
  try {
    sessionStorage.removeItem(RELOAD_FLAG);
  } catch (e) {
    // storage is unavailable, nothing to clear
  }
};
